import script from "./BlogPostPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostPage.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostPage.vue?vue&type=style&index=0&id=411aec67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-411aec67"]])

export default __exports__